import { clsx } from 'clsx';
import Icon from 'src/common/components/Icon';

import styles from './BasicItem.module.scss';

interface Props {
  className?: string;
  name: string;
}

const BasicItem = ({ className, name }: Props) => (
  <div className={clsx(styles.basicItemContainer, className)}>
    <div className={styles.basicItemCard}>
      <Icon name="ingredient" size={20} color="ACTION_DEFAULT" />
    </div>
    <p className={styles.basicIngredientName}>{name}</p>
  </div>
);

export default BasicItem;
